import { render, staticRenderFns } from "./errorOccured.vue?vue&type=template&id=aa6f162a"
import script from "./errorOccured.vue?vue&type=script&lang=js"
export * from "./errorOccured.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports